"use strict";
// TODO: Replace with a more sophisticated logging solution
Object.defineProperty(exports, "__esModule", { value: true });
exports.withLogger = exports.createDebugLogger = void 0;
const logFormatter_1 = require("./logFormatter");
const createDebugLogger = (name, formatter) => () => {
    const entries = [];
    let isEnabled = false;
    return {
        enable: () => {
            isEnabled = true;
        },
        debug: (...args) => {
            if (isEnabled) {
                entries.push(args.map(arg => (typeof arg === 'function' ? arg() : arg)));
            }
        },
        commit: () => {
            if (isEnabled) {
                console.log(`Clerk debug start :: ${name}\n${entries
                    .map(log => formatter(log))
                    .map(e => `-- ${e}\n`)
                    .join('')}`);
            }
        },
    };
};
exports.createDebugLogger = createDebugLogger;
const withLogger = (loggerFactoryOrName, handlerCtor) => {
    return ((...args) => {
        const factory = typeof loggerFactoryOrName === 'string'
            ? (0, exports.createDebugLogger)(loggerFactoryOrName, logFormatter_1.logFormatter)
            : loggerFactoryOrName;
        const logger = factory();
        const handler = handlerCtor(logger);
        try {
            const res = handler(...args);
            if (typeof res === 'object' && 'then' in res && typeof res.then === 'function') {
                return res
                    .then((val) => {
                    logger.commit();
                    return val;
                })
                    .catch((err) => {
                    logger.commit();
                    throw err;
                });
            }
            // handle sync methods
            logger.commit();
            return res;
        }
        catch (err) {
            logger.commit();
            throw err;
        }
    });
};
exports.withLogger = withLogger;
